import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMarginLeft12 from './IconMarginLeft12';
import IconMarginLeft16 from './IconMarginLeft16';
import IconMarginLeft20 from './IconMarginLeft20';
import IconMarginLeft24 from './IconMarginLeft24';
import IconMarginLeft32 from './IconMarginLeft32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMarginLeft = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMarginLeft12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMarginLeft16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMarginLeft20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMarginLeft24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMarginLeft32 {...props} />}
        </span>
    );
};
IconMarginLeft.displayName = 'FondueIconMarginLeft';

export default memo(IconMarginLeft);
